import { createSlice } from "@reduxjs/toolkit";

export const filterSlice = createSlice({
  name: "filters",
  initialState: {
    filters: {},
  },
  reducers: {
    setFilters: (state, action) => {
      return { ...action.payload };
    },
    ResetFilter: (state) => {
      return { filters: {} }
    }
  },
});

export const { setFilters, ResetFilter } = filterSlice.actions;

export default filterSlice.reducer;
